<template>
  <div>
    <MultiRangeSlider
      baseClassName="multi-range-slider-bar-only"
      :minValue="oBarMinValue"
      :maxValue="oBarMaxValue"
      :max="maxValue"
      :min="minValue"
      :step="getStep()"
      :rangeMargin="0"
      @input="update_oBarValues"
    />
    <div class="input-wrapper">
      <div class="input-box">
        <div class="min-max-text">min</div>
        <input
          class="input-form"
          :class="isInvalidMinValue ? 'invalid-input' : ''"
          type="number"
          v-model.number="oBarMinValue"
        />
      </div>
      <div class="input-box">
        <div class="min-max-text">max</div>
        <input
          class="input-form"
          :class="isInvalidMaxValue ? 'invalid-input' : ''"
          type="number"
          v-model.number="oBarMaxValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MultiRangeSlider from 'multi-range-slider-vue';
import '../../../node_modules/multi-range-slider-vue/MultiRangeSliderBarOnly.css';

export default {
  props: ['traitType', 'minValue', 'maxValue'],
  components: { MultiRangeSlider },
  data() {
    return {
      oBarMinValue: this.minValue,
      oBarMaxValue: this.maxValue,
      isReset: false
    };
  },
  computed: {
    isInvalidMinValue() {
      return (
        this.oBarMinValue > this.oBarMaxValue ||
        this.oBarMinValue === '' ||
        this.oBarMinValue < this.minValue
      );
    },
    isInvalidMaxValue() {
      return (
        this.oBarMinValue > this.oBarMaxValue ||
        this.oBarMaxValue === '' ||
        this.oBarMaxValue > this.maxValue
      );
    }
  },
  watch: {
    oBarMinValue() {
      this.$emit(
        'handleSearch',
        this.traitType,
        this.traitType === 'level' ? this.oBarMinValue - 1 : this.oBarMinValue,
        this.traitType === 'level' ? this.oBarMaxValue - 1 : this.oBarMaxValue
      );
    },
    oBarMaxValue() {
      this.$emit(
        'handleSearch',
        this.traitType,
        this.traitType === 'level' ? this.oBarMinValue - 1 : this.oBarMinValue,
        this.traitType === 'level' ? this.oBarMaxValue - 1 : this.oBarMaxValue
      );
    }
  },
  methods: {
    update_oBarValues(e) {
      if (!this.isReset) {
        if (e.maxValue === '' || e.minValue === '') return;
        this.oBarMinValue = e.minValue;
        this.oBarMaxValue = e.maxValue;
      } else {
        this.isReset = false;
      }
    },
    getStep() {
      if (this.traitType === 'baseline' || this.traitType === 'goldRate') return 0.1;
      return 1;
    },
    resetValue() {
      this.isReset = true;
      this.oBarMinValue = this.minValue;
      this.oBarMaxValue = this.maxValue;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .multi-range-slider-bar-only {
  .thumb {
    &::before {
      width: 14px;
      height: 14px;
      box-shadow: none;
      border: solid 2px #3f51d9;
      margin-top: -5px;
    }
    &.thumb-left::before {
      margin-left: 5px;
    }
    &.thumb-right::before {
      margin-left: -10px;
    }
    .caption {
      display: none;
    }
  }
  .bar-inner {
    height: 5px;
    background-color: #3f51d9;
    border: none;
    box-shadow: none;
  }
  .bar-left,
  .bar-right {
    box-shadow: none;
    border: none;
  }
}
.input-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  .input-box {
    position: relative;
    .min-max-text {
      margin-top: 4px;
      width: 100%;
      text-align: center;
      position: absolute;
      color: #828c9f;
    }
    .input-form {
      display: inline-block;
      padding: 24px 10px 4px;
      background: #ffffff;
      color: #828c9f;
      border: solid 1px #f3f5fa;
      border-radius: 4px;
      width: 70px;
      margin: 3px;
      text-align: center;
      &.invalid-input {
        border: solid 2px #e31919;
        &:focus-visible {
          outline: none !important;
          border: solid 2px #e31919 !important;
        }
      }
    }
  }
}
</style>
